import { ReactComponent as Logo } from '../../assets/icons/volume down 1.svg'

const Volumnn = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Volumnn
